export default __webpack_public_path__ + "static/media/PromoCTA.4c9b24d9.jpg";